import axios from 'axios'

export const API_URL = 'https://globalreceipt.com:8080/api'

// Attach auth token automatically for all API calls.
axios.interceptors.request.use((config) => {
  const userInfoRaw = localStorage.getItem('userInfo')
  const ownerInfoRaw = localStorage.getItem('ownerInfo')

  const userInfo = userInfoRaw ? JSON.parse(userInfoRaw) : null
  const ownerInfo = ownerInfoRaw ? JSON.parse(ownerInfoRaw) : null
  const token = userInfo?.token || ownerInfo?.token

  if (token) {
    config.headers = {
      ...config.headers,
      Authorization: `Bearer ${token}`
    }
  }

  return config
})

// Centralised 401 handling: clear stale tokens and redirect to login
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('userInfo')
      localStorage.removeItem('ownerInfo')
      window.location.href = '/login'
    }
    return Promise.reject(error)
  }
)
